const calendar = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M12.75 1h-1.5v2h-6.5V1h-1.5v2H1v12h14V3h-2.25zM2.5 13.5V7h11v6.5z"/></svg>',
};

export { calendar as default };
